// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".what__container{margin-top:40px!important;padding:0}.what__container--title{margin:24px 60px 30px 16px}.what__container-box>li{border-bottom:1px solid #ccc;margin:20px 0}.what__container-box--title{color:#242424;font-size:1.2rem;font-weight:700;margin:0 0 10px!important;line-height:24px}.what__container-box--description{color:#242424;font-size:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
